import { extractErrorCode } from './error-handler';

import type { AxiosError } from 'axios';

/**
 * G7(구멍 점검, 팀장 2026-10-18 · backend TRAD-3767) — 필수 미동의 회원의 쓰기 요청에 서버가 403 TERMS_007 CONSENT_REQUIRED 를 낸다.
 * PrivateRoute 는 «로그인 상태가 바뀔 때»만 동의를 묻기 때문에 «로그인해 있는 동안 약관이 바뀐» 회원을 못 잡는다 — 이 응답이 그 경로다.
 * 공통 응답 처리(handlers.ts) 한 곳에서 이 이벤트를 쏘고, 라우터 안의 `ConsentRequiredRedirect` 가 동의 화면으로 보낸다.
 */
export const CONSENT_REQUIRED_CODE = 'TERMS_007';
export const CONSENT_REQUIRED_EVENT = 'consent:required';

export const isConsentRequiredError = (error: AxiosError): boolean =>
  error.response?.status === 403 && extractErrorCode(error) === CONSENT_REQUIRED_CODE;

/**
 * TRAD-3777(서버 강제 = backend TRAD-3774) — 하우스 룰(EULA) 미동의 회원의 글·댓글 쓰기에 서버가 403 TERMS_008 HOUSE_RULE_REQUIRED 를 낸다.
 * 클라 진입점 게이트(HouseRuleGate)를 거치지 않은 쓰기(새 화면·옛 탭)가 이 경로다. 같은 공통 응답 처리에서 이벤트를 쏘고,
 * 라우터 안의 `HouseRuleRequiredListener` 가 글쓰기 때와 «같은» 하우스 룰 다이얼로그를 연다.
 */
export const HOUSE_RULE_REQUIRED_CODE = 'TERMS_008';
export const HOUSE_RULE_REQUIRED_EVENT = 'consent:house-rule-required';

export const isHouseRuleRequiredError = (error: AxiosError): boolean =>
  error.response?.status === 403 && extractErrorCode(error) === HOUSE_RULE_REQUIRED_CODE;
